import i18n from "i18next"
import XHR from "i18next-xhr-backend"
import LanguageDetector from "i18next-browser-languagedetector"
import { reactI18nextModule } from "react-i18next"
import apiConfig from "./apiConfig"

i18n
  .use(XHR)
  .use(LanguageDetector)
  .use(reactI18nextModule)
  .init({
    /*backend: {
      loadPath: function() {
        const clientId = 12 // Grab this from the JWT/Cookie etc
        // Then hit the API (the reporting one, not the main TT one)
        // to get the Translations needed for the reporting frontend
        // by client/lanugage
        // See C:\Users\hello\Documents\Visual Studio 2017\Projects\ReportingTranslationsApi\ReportingTranslationsApi
        // for the API example
        return apiConfig.createUrl(`/translations/{{lng}}/${clientId}`)
      }
    },*/

    fallbackLng: "en-GB",

    // have a common namespace used around the full app
    ns: ["translations"],
    defaultNS: "translations",

    debug: false, // Can be useful during development

    interpolation: {
      escapeValue: false // not needed for react!!
    },

    react: {
      wait: true
    }
  })

export default i18n



// WEBPACK FOOTER //
// ./src/i18n.js